export const menuItems = [
  {
    name: 'Lobby',
    link: '/',
    iconName: 'icon-home',
  },
  {
    name: 'Matches',
    link: '/matches',
    iconName: 'icon-cup',
  },
  {
    name: 'Teams',
    link: '/teams',
    iconName: 'icon-teams',
  },
  {
    name: 'Clubs',
    link: '/clubs',
    iconName: 'icon-clubs',
  },
  {
    name: 'Hand history',
    link: '/hand-history',
    iconName: 'icon-hand-history',
  },
  {
    name: 'Leaderboard',
    link: '/leaderboard',
    iconName: 'icon-leaderboard',
  },
  {
    name: 'Replayer',
    link: '/replayer',
    iconName: 'icon-replayer',
  },
];
